import React, { FC } from "react";
import { useTranslation } from "react-i18next";

interface PaginationTotalProps {
  total: number;
}

const PaginationTotal: FC<PaginationTotalProps> = ({ total }) => {
  const { t } = useTranslation();

  return (
    <span className="text-xs text-gray-400 font-normal">
      {t("pagination.total", { value: total })}
    </span>
  );
};

// Ready-to-use `showTotal` callback for antd Table/Pagination configs.
const renderPaginationTotal = (total: number) => (
  <PaginationTotal total={total} />
);

export { PaginationTotal, renderPaginationTotal };
